exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".flexstuff svg{position:sticky;top:30px}.flexstuff.fs200 svg{height:200px;width:200px}.flexstuff.fs150 svg{height:150px;width:150px}.flexstuff.fs100 svg{height:100px;width:100px}.flexstuff.fs50 svg{height:50px;width:50px}.vcenter{margin:auto;margin-left:0;margin-right:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-38814ea6","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/IconTable.vue
// module id = 399
// module chunks = 0